import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";

/** a firm id is a positive whole number - anything else in the url is ignored */
function parseFirmId(firm: string | null): number | null {
  return firm && /^[1-9]\d*$/.test(firm) ? parseInt(firm, 10) : null;
}

// reads ?firm= and ?theatre= - suspends during prerender with Cache Components, so call it inside <Suspense>
export function useProgramSearchParams() {
  const $ = _c(7);
  const params = useSearchParams();
  let t0;
  if ($[0] !== params) {
    t0 = parseFirmId(params.get("firm"));
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = params.get("theatre");
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      firmId: t0,
      theatre: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}